import script from "./TestProductList.vue?vue&type=script&setup=true&lang=js"
export * from "./TestProductList.vue?vue&type=script&setup=true&lang=js"

import "./TestProductList.vue?vue&type=style&index=0&id=a5c1e784&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5c1e784"]])

export default __exports__